import { BadgeM } from "@common/components/badge/BadgeM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

export function ParentCallRequestedBadge(props) {
    return (
        <BadgeM
            style={{
                backgroundColor:
                    props.user?.profile?.parent_call_requested === 0
                        ? theme.colors.lighter
                        : theme.colors.successLight,
                ...props.style,
            }}
            count={
                <>
                    <FontAwesome5
                        name={"phone"}
                        solid
                        color={
                            props.user?.profile?.parent_call_requested === 0
                                ? theme.colors.light
                                : theme.colors.success
                        }
                        size={12}
                        style={{ marginRight: 3 }}
                    />
                    <TextM
                        fontWeight="Bold"
                        color={
                            props.user?.profile?.parent_call_requested === 0
                                ? theme.colors.light
                                : theme.colors.success
                        }
                        fontSize={12}
                    >
                        {props.user?.profile?.parent_call_requested === 0
                            ? "Non"
                            : "Oui"}
                    </TextM>
                </>
            }
            size={14}
        />
    )
}
